(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["load-list"] = factory();
	else
		root["rich"] = root["rich"] || {}, root["rich"]["load-list"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 438);
/******/ })
/************************************************************************/
/******/ ({

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(439)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('../../components/load-list/load-list'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.loadList);
    global.index = mod.exports;
  }
})(this, function (module, exports, _loadList) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _loadList2 = _interopRequireDefault(_loadList);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  _loadList2.default.install = function (Vue) {
    Vue.component(_loadList2.default.name, _loadList2.default);
  };

  exports.default = _loadList2.default;
  module.exports = exports['default'];
});

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(440)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(442),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-702968f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 440:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports);
    global.loadList = mod.exports;
  }
})(this, function (module, exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });


  var COMPONENT_NAME = 'rich-load-list';

  var EMPTY = 1;
  var NO_MORE = 2;
  var EVENT_LOADDATA = 'loaddata';
  var EVENT_REFRESH = 'refresh';
  exports.default = {
    name: COMPONENT_NAME,
    props: {
      pullDownRefresh: {
        type: Boolean,
        default: false
      },
      pullUpLoad: {
        type: Boolean,
        default: false
      },
      autoload: {
        type: Boolean,
        default: false
      }
    },
    data: function data() {
      return {
        pullDownStyle: 'top: 0px; opacity: 0',
        noMore: false,
        pendingPullUp: false,
        pendingPullDown: false,
        options: {
          scrollbar: true,
          pullDownRefresh: this.pullDownRefresh ? {
            threshold: 60,
            stop: 40,
            stopTime: 50,
            txt: '更新成功'
          } : false,
          pullUpLoad: this.pullUpLoad ? {
            threshold: 0
          } : false
        },
        isEmpty: false
      };
    },

    watch: {
      isEmpty: function isEmpty(val) {
        if (val) {
          this.$refs.scroll.disable();
        } else {
          this.$refs.scroll.enable();
        }
      }
    },
    created: function created() {
      if (this.autoload) {
        this.refresh();
      }
    },

    methods: {
      onPullingDown: function onPullingDown() {
        var _this = this;

        if (this.pendingPullDown) {
          return;
        }

        this.noMore = false;
        this.pendingPullDown = true;

        setTimeout(function () {
          _this.refresh();
        }, 500);
      },
      onPullingUp: function onPullingUp() {
        var _this2 = this;

        if (this.noMore) {
          this.updateScroll();
          return;
        }

        if (this.pendingPullUp) {
          return;
        }

        this.updateScroll(true);
        this.pendingPullUp = true;

        this.$emit(EVENT_LOADDATA, function (status) {
          if (status === EMPTY) {
            _this2.isEmpty = true;
          }

          if (status === NO_MORE) {
            _this2.noMore = true;
          }

          _this2.pendingPullUp = false;
          _this2.updateScroll(true);
        });
      },
      refresh: function refresh() {
        var _this3 = this;

        this.noMore = false;
        this.isEmpty = false;

        this.toast = this.$createToast({
          type: 'loading',
          effect: 'light',
          time: 0,
          mask: true
        });

        if (!this.pendingPullDown) {
          this.toast.show();
        }

        this.$emit(EVENT_REFRESH, function (status) {
          if (!_this3.pendingPullDown) {
            _this3.toast.hide();
          }

          if (status === EMPTY) {
            _this3.isEmpty = true;
          }

          if (status === NO_MORE) {
            _this3.noMore = true;
          }

          _this3.pendingPullDown = false;
          _this3.updateScroll(true);
          if (_this3.$refs.scroll) {
            _this3.$refs.scroll.scrollTo(0, 0);
          }
        });
      },
      updateScroll: function updateScroll(refresh) {
        var _this4 = this;

        this.$nextTick(function () {
          if (_this4.$refs.scroll) {
            _this4.$refs.scroll.forceUpdate();
            if (refresh) {
              _this4.$refs.scroll.refresh();
            }
          }
        });
      },
      onScroll: function onScroll(pos) {
        if (pos.y > 0) {
          this.pullDownStyle = 'top:' + Math.round(pos.y * 0.5) + 'px; opacity: ' + pos.y / 60;
        } else {
          this.pullDownStyle = 'top: 0px; opacity: 0';
        }
      }
    }
  };
  module.exports = exports['default'];
});

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('rich-scroll', {
    ref: "scroll",
    attrs: {
      "options": _vm.options,
      "scroll-events": ['scroll', 'scroll-end']
    },
    on: {
      "scroll": _vm.onScroll,
      "pulling-down": _vm.onPullingDown,
      "pulling-up": _vm.onPullingUp
    },
    scopedSlots: _vm._u([{
      key: "pulldown",
      fn: function(props) {
        return (!_vm.isEmpty) ? [_c('div', {
          staticClass: "load-list-pulldown-wrapper",
          style: (_vm.pullDownStyle)
        }, [_c('rich-loading', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (
              props.pullDownRefresh &&
              (props.isPullingDown || !props.beforePulldown)
            ),
            expression: "\n          props.pullDownRefresh &&\n            (props.isPullingDown || !props.beforePulldown)\n        "
          }]
        })], 1)] : undefined
      }
    }], null, true)
  }, [_vm._t("default"), _vm._v(" "), (_vm.isEmpty) ? _vm._t("empty") : _vm._e(), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "pullup"
  }, [(!_vm.noMore && _vm.pendingPullUp) ? _c('div', {
    staticClass: "load-list-pullup-wrapper"
  }, [_c('rich-loading')], 1) : _vm._e(), _vm._v(" "), (_vm.noMore && !_vm.isEmpty) ? _c('div', {
    staticClass: "load-list-pullup-wrapper"
  }, [_vm._t("nomore")], 2) : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ })

/******/ });
});